import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noDecimal'
})
export class NoDecimalPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    if (value) {
      return Number(value.toString().replace(",", "")).toFixed(2);
    }
  }

}
